import { EnquiryLifecycleStatusEnum } from "../enum"

export class QuoteRequest{
    enquiryId:number
    addedPriceToRmrate:number
    reducedPriceToRmRate:number
    leadStatus:EnquiryLifecycleStatusEnum
    productPrices:ProductQuotePrices[]
    constructor(enquiryId:number,addedPriceToRmrate:number,reducedPriceToRmRate:number,leadStatus:EnquiryLifecycleStatusEnum,productPrices:ProductQuotePrices[]){
        this.enquiryId = enquiryId
        this.addedPriceToRmrate = addedPriceToRmrate
        this.reducedPriceToRmRate = reducedPriceToRmRate
        this.productPrices = productPrices
        this.leadStatus = leadStatus
    }
}
export class ProductQuotePrices{
    productId:number
    quotePrice:number // quote req(send while quote price update)
    costOfSalesForAddedRmRate:number // quote req(send while quote price update)
    costOfSalesForReducedRmRate:number // quote req(send while quote price update)
    incentives: number  // quote req(send while quote price update)
    totalPL:number // if buyer price is already existed then send while quote price update otherwise send while buyer price update
    plPercentage:number // if buyer price is already existed then send while quote price update otherwise send while buyer price update
    contributionPercentage: number // if buyer price is already existed then send while quote price update otherwise send while buyer price update
    buyerPrice: number  //buyer req (send while buyer price update)
    netPLOnBuyerPrice: number // buyer req (send while buyer price update)
    productName?:string
    category?:string
    styleWeighment?:string
    adCvdPercent?: number
    totalCostOfSalesPerLb?: number
    enquiryProductId?:number
    buyerOfferPrice?:number
    netWeight?:number
}